import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import initialReducer from '@/reducers/initialSlices';
import currentPageReducer from '@/reducers/currentPage';
import LoanApplicationReducer from '@/reducers/LoanApplication';
import CurrentFormReducer from '@/reducers/CurrentForm';
import TemplateConfigReducer from '@/reducers/TemplateConfig';
import VmoV2Reducer from '@/reducers/VmoV2';

const rootReducer = combineReducers({
  initial: initialReducer,
  currentPage: currentPageReducer,
  LoanApplication: LoanApplicationReducer,
  CurrentForm: CurrentFormReducer,
  TemplateConfig: TemplateConfigReducer,
  VmoV2: VmoV2Reducer,
});

const persistConfig = {
  key: 'root',
  storage: storageSession, //sessionStorage
  whitelist: ['currentPage', 'LoanApplication', 'CurrentForm', 'TemplateConfig', 'VmoV2'], //persisted reducers
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Add type for persisted state
declare module 'redux-persist' {
  interface PersistPartial {
    currentPage: ReturnType<typeof currentPageReducer>;
    LoanApplication: ReturnType<typeof LoanApplicationReducer>;
    CurrentForm: ReturnType<typeof CurrentFormReducer>;
    TemplateConfig: ReturnType<typeof TemplateConfigReducer>;
    VmoV2: ReturnType<typeof VmoV2Reducer>;
  }
}
